import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthHeroPanel } from "@/components/auth/AuthHeroPanel";
import { EmailPasswordForm } from "@/components/auth/EmailPasswordForm";

export default function AuthPage() {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const [mode, setMode] = useState("login"); // "login" | "register"

  useEffect(() => {
    if (user) {
      if (user.role === "admin") navigate("/admin");
      else if (user.role === "council_member") navigate("/council");
      else navigate("/dashboard");
    }
  }, [user, navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex">
      <AuthHeroPanel />

      {/* Right panel */}
      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm">
          {/* Logo */}
          <div className="flex items-center gap-2 mb-10">
            <div className="w-7 h-7 bg-[#0F172A] rounded-sm flex items-center justify-center">
              <span className="text-white text-xs font-bold font-serif">C</span>
            </div>
            <span className="text-[#0F172A] font-semibold text-base">
              Council<span className="text-[#064E3B]">One</span>
            </span>
          </div>

          <h2 className="text-3xl font-normal text-[#0F172A] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            {mode === "login" ? "Welcome back" : "Join as Explorer"}
          </h2>
          <p className="text-[#52525B] text-sm mb-6">
            {mode === "login" ? "Sign in to access your expert network." : "Create your free account to meet the experts."}
          </p>

          <EmailPasswordForm mode={mode} onSuccess={setUser} />

          <p className="text-xs text-[#52525B] text-center mt-4">
            {mode === "login" ? (
              <>Don&apos;t have an account?{" "}
                <button onClick={() => setMode("register")} className="text-[#064E3B] font-semibold hover:underline" data-testid="switch-to-register">
                  Create one
                </button>
              </>
            ) : (
              <>Already have an account?{" "}
                <button onClick={() => setMode("login")} className="text-[#064E3B] font-semibold hover:underline" data-testid="switch-to-login">
                  Sign in
                </button>
              </>
            )}
          </p>

          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-[#E4E4E1]" />
            </div>
            <div className="relative flex justify-center">
              <span className="bg-[#FAFAF8] px-3 text-xs text-[#A1A1AA]">or</span>
            </div>
          </div>

          <button
            onClick={handleGoogleLogin}
            className="w-full flex items-center justify-center gap-3 bg-white border border-[#E4E4E1] text-[#0F172A] px-6 py-3 rounded-sm font-semibold text-sm hover:bg-[#F4F4F1] hover:border-[#0F172A] transition-colors duration-200 shadow-sm"
            data-testid="google-sign-in-button"
          >
            <svg width="18" height="18" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continue with Google
          </button>

          <div className="text-center mt-6">
            <p className="text-xs text-[#A1A1AA]">
              Invited as a Council Member? Use the invitation link from your email — it works with either sign-in method.
            </p>
          </div>

          <p className="text-[10px] text-[#A1A1AA] text-center mt-6 leading-relaxed">
            By continuing, you agree to CouncilOne&apos;s{" "}
            <a href="#" className="underline">Terms of Service</a> and{" "}
            <a href="#" className="underline">Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  );
}
